/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expired_Token_AccountInputs */



/**
* | output |
* | --- |
* | "Your account activation period has expired To receive a new link by email, click the button below" |
*
* @param {Expired_Token_AccountInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const expired_token_account = /** @type {((inputs?: Expired_Token_AccountInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expired_Token_AccountInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Your account activation period has expired\nTo receive a new link by email, click the button below")
	return /** @type {LocalizedString} */ ("Le délai d'activation de votre compte a expiré\nPour recevoir un nouveau lien par email, cliquer sur le bouton ci-dessous")
});